"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timezones = void 0;
const moment = require('moment-timezone');
exports.timezones = moment.tz.names();
//# sourceMappingURL=timezones.js.map